import ComponentWithSocket from '../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from '../../store';

import template from './homepage.vue';

// Websockets
import { WebsocketsListener } from '../../utils/ws';

@Component({
    mixins: [template]
})

export default class Homepage extends ComponentWithSocket {

    private counts: any = { auctions: 0, lots: 0 };

    constructor() {

        super();

        this.wsListener.onGet('admin.dashboard.counts', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.counts.auctions = data.auctions;
                this.counts.lots = data.lots;
            }

        });

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        Store.commitLoaderVisibility(this.$store, false);

        this.wsListener.sendGet('admin.dashboard.counts');

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/homepage/index.ts